import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-333846e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home-container",
  id: "ticketTypes"
}
const _hoisted_2 = { class: "app__title" }
const _hoisted_3 = { class: "ticketType__overlay-container" }
const _hoisted_4 = { class: "ticketType__overlay-container-inside" }
const _hoisted_5 = { class: "circle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"75px","padding":"0.2rem"},
  src: "https://i.ibb.co/4g0P229/ticket-Type-image.png"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { style: {"height":"12.8rem"} }
const _hoisted_9 = { class: "ticket-type__title gray__base__color mt" }
const _hoisted_10 = { class: "ml" }
const _hoisted_11 = { class: "ticket-type__description gray__base__color" }
const _hoisted_12 = { class: "button__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return ($setup.eventData && $setup.eventData.ticketTypes && $setup.isOnlineRegistractionActive)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("register.title")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 20,
          class: "justify-center"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.eventData.ticketTypes, (ticket, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 6,
                lg: 6,
                xl: 6,
                key: ticket.id + index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    shadow: "always",
                    id: "ticketType",
                    class: _normalizeClass('ticketType__overlay' + (index + 1))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", {
                              class: _normalizeClass('inner__circle' + (index + 1))
                            }, _hoisted_7, 2)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(ticket.name), 1),
                            _createElementVNode("p", {
                              class: _normalizeClass('ticket-type__price' + (index + 1))
                            }, [
                              _createTextVNode(" $ " + _toDisplayString(ticket.price), 1),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(ticket.currency), 1)
                            ], 2),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(ticket.description), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            (!$setup.statusPaid)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  onClick: ($event: any) => ($setup.goTo('Register', ticket.id)),
                                  class: "secondary__color__button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}